import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { usePacientes } from '../hooks/usePacientes';
import { AnamnesisForm } from '../components/assessment/AnamnesisForm';
import { ExamsForm } from '../components/assessment/ExamsForm';
import './Pages.css';

export const Assessment: React.FC = () => {
  const { pacientes } = usePacientes();
  const [searchParams, setSearchParams] = useSearchParams();
  const patientId = searchParams.get('patientId');
  const [selectedPatientId, setSelectedPatientId] = useState<string>(patientId || '');
  const [activeTab, setActiveTab] = useState<'anamnesis' | 'exams'>('anamnesis');

  return (
    <div className="ns-page">
      <div className="ns-page-header">
        <div>
          <h2>Avaliação Nutricional</h2>
          <p>Anamnese completa e exames laboratoriais do paciente.</p>
        </div>
      </div>

      <div className="ns-grid ns-grid-2">
        <Card title="Seleção de Paciente" subtitle="Escolha o paciente para avaliação">
          <div className="ns-form">
            <label className="ns-field">
              <span>Paciente *</span>
              <select
                className="ns-input"
                value={selectedPatientId}
                onChange={(e) => {
                  setSelectedPatientId(e.target.value);
                  setSearchParams({ patientId: e.target.value });
                }}
                style={{ textDecoration: 'none' }}
              >
                <option value="">Selecione um paciente</option>
                {pacientes.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.nome}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </Card>

        {selectedPatientId && (
          <Card title="Seções da Avaliação" subtitle="Escolha a seção para preencher">
            <div className="ns-tab-selector">
              <button
                type="button"
                className={activeTab === 'anamnesis' ? 'active' : ''}
                onClick={() => setActiveTab('anamnesis')}
              >
                Anamnese
              </button>
              <button
                type="button"
                className={activeTab === 'exams' ? 'active' : ''}
                onClick={() => setActiveTab('exams')}
              >
                Exames
              </button>
            </div>
          </Card>
        )}
      </div>

      {selectedPatientId && (
        <div className="ns-assessment-content">
          {activeTab === 'anamnesis' && (
            <AnamnesisForm
              patientId={selectedPatientId}
              onSave={() => {
                // Opcional: feedback após salvar
              }}
            />
          )}

          {activeTab === 'exams' && (
            <ExamsForm
              patientId={selectedPatientId}
              onSave={() => {
                // Opcional: feedback após salvar
              }}
            />
          )}
        </div>
      )}

      {!selectedPatientId && (
        <Card title="Instruções" subtitle="Como usar esta página">
          <div className="ns-instructions">
            <p>1. Selecione um paciente no campo acima</p>
            <p>2. Escolha a seção (Anamnese ou Exames)</p>
            <p>3. Preencha os dados e salve</p>
            <p>
              <strong>Anamnese:</strong> Histórico alimentar, rotina, preferências, histórico médico
            </p>
            <p>
              <strong>Exames:</strong> Registre exames laboratoriais com parâmetros e valores
            </p>
          </div>
        </Card>
      )}
    </div>
  );
};

